import { useColorMode as useVueUseColorMode } from '@vueuse/core'
import { computed } from 'vue'

export function useColorMode() {
  const { system, store } = useVueUseColorMode({
    initialValue: 'auto',
    storageKey: 'color-mode',
  })

  const mode = computed(() => (store.value === 'auto' ? system.value : store.value))

  return {
    mode,
    store,
  }
}
